import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingFormTypes } from "models/formTypes";
import { CompFormViewProps } from "models/propTypes/timeReportingPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CompForm: ForwardRefRenderFunction<FormHandles, CompFormViewProps> = (props, ref) => {
  const { onCompHoursChanage, monthName } = props;
  return (
    <GenericForm<TimeReportingFormTypes.EditCompHours>
      formRef={ref}
      {...props}
      fields={{
        addHours: {
          label: "",
          type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
          innerFields: {
            addHours: {
              label: TranslationKeys.TimeReporting.AddOrRemoveCompTime,
              controlLabel: "",
              type: FormEnums.FormFieldType.NUMBER,
              widthColumnCount: 6,
              onChangeHandler: onCompHoursChanage,
            },
            totalHours: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.TotalCompTime, "", {
                monthLong: monthName ?? "",
              }),
              controlLabel: "",
              type: FormEnums.FormFieldType.NUMBER,
              readonly: true,
              widthColumnCount: 6,
              extraProps: { suffix: "h" },
            },
          },
        },
      }}
      hideErrorBubble
    />
  );
};

export default forwardRef(CompForm);
